import { ArrowRight, Check } from 'lucide-react'

import { BrandMark } from '../../components/BrandMark'
import { Button } from '../../components/ui'

interface SubmissionSuccessProps {
  onStartAnother: () => void
}

export function SubmissionSuccess({ onStartAnother }: SubmissionSuccessProps) {
  return (
    <main className="success-screen">
      <header><BrandMark inverted /></header>
      <section className="success-screen__content">
        <div className="success-screen__mark"><Check aria-hidden="true" /></div>
        <h1>Your nug shots are with the editors.</h1>
        <p>
          High Times has received your images, credits and strain details. The team will use your email if anything
          else is needed.
        </p>
        <div className="success-screen__actions">
          <Button onClick={onStartAnother} icon={<ArrowRight size={20} />}>Send another submission</Button>
          <a href="https://hightimes.com" rel="noreferrer">Return to High Times</a>
        </div>
      </section>
      <img src="/images/nugshot-hero.jpg" alt="Cannabis flower detail" />
    </main>
  )
}
